export default "__VITE_ASSET__tODHJiOg__"